export default {
  meta: {
    title: '周边查询',
    url: '/insight/map', // 埋点字段，上报归属的模块
    urlName: '周边查询' // 埋点字段，上报归属的模块
    // eventId: '186215a0-32cb-4c74-bd39-771a9140dd20'
  }
};
